import ExternalApiRequest from '../externalApiRequest';

const logout = () => {
    const options = {
        api: 'logout'
    };
    return ExternalApiRequest(options);
};

export default logout;
